import React, { Component } from "react";
import PropTypes from "prop-types";
import FormGroup from '@material-ui/core/FormGroup';
import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

class SwitchInput extends Component {
  static propTypes = {
    options: PropTypes.object.isRequired
  };

  render() {
    const {
      name,
      onChange,
      labelA,
      labelB,
      checked
    } = this.props.options;

    const CustomSwitch = withStyles((theme) => ({
      root: {
        width: 64,
        height: 29,
        padding: 0,
        margin: theme.spacing(1),
      },
      switchBase: {
        padding: 1,
        '&$checked': {
          transform: 'translateX(35px)',
          color: theme.palette.common.white,
          '& + $track': {
            backgroundColor: '#3BCFB2',
            opacity: 1,
            border: 'none',
          },
        },
        '&$focusVisible $thumb': {
          color: '#3BCFB2',
          border: '6px solid #fff',
        },
      },
      thumb: {
        width: 27,
        height: 27,
      },
      track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
      },
      checked: {},
      focusVisible: {},
    }))(({ classes, ...props }) => {
      return (
        <Switch
          focusVisibleClassName={classes.focusVisible}
          disableRipple
          classes={{
            root: classes.root,
            switchBase: classes.switchBase,
            thumb: classes.thumb,
            track: classes.track,
            checked: classes.checked,
          }}
          {...props}
        />
      );
    });

    return (
      <FormGroup row className="h-100 ml-2">
        <Typography component="div">
          <Grid component="label" container alignItems="center" spacing={1}>
            <Grid item>{labelA}</Grid>
            <Grid item>
              <CustomSwitch checked={checked} onChange={onChange} name={name} />
            </Grid>
            <Grid item>{labelB}</Grid>
          </Grid>
        </Typography>
      </FormGroup>
    );
  }
}

export default SwitchInput;